import React, { Component } from 'react';

import { getVoices, onvoiceschanged } from '../modules/audio';

class Requirements extends Component {
  constructor(props) {
    super(props);

    this.state = {
      voices: [],
    };
  }

  componentWillMount() {
    this.updateVoices();
  }

  componentDidMount() {
    // getVoices on speechSynthesis will return an empty array if called too early.
    // This hooks into SpeechSynthesis' onchange event for voices.
    onvoiceschanged(this.updateVoices);
  }

  updateVoices = () => {
    this.setState({ voices: getVoices() });
  }


  render() {
    const isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && navigator.userAgent.toLowerCase().indexOf('edge') === -1 && navigator.userAgent.toLowerCase().indexOf('opr') === -1;

    if (!isChrome) {
      return (
        <div key="requirements">
          <p>Pronounce Live runs on the Google Chrome browser.</p>
          <p>Please check this page with Chrome to see supported languages.</p>
        </div>
      );
    }


    return (
      <div key="requirements">
        <p className="requirement">Pronounce Live runs on the Google Chrome browser.</p>
        <p className="requirement">View below which languages are supported by your browser.</p>
        <select className="requirement">
          {this.state.voices.map((voice, index) => <option key={index}>{voice.languageName}</option>)}
        </select>
      </div>
    );
  }
}

export default Requirements;



// WEBPACK FOOTER //
// ./src/components/Requirements.js